import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "login-form__title" }, "Log in", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "login-form__description" }, [
  /*#__PURE__*/_createTextVNode(" Welcome to "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" the I'am app. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Forgot your password? ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "login-form-contact" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "login-form-contact__description" }, [
    /*#__PURE__*/_createTextVNode(" If you have any questions, "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" please contact us: "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" hello@glazeprosthetics.com ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_item = _resolveComponent("form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_form_element = _resolveComponent("form-element")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createBlock(_component_base_form, { class: "login-form" }, {
    header: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_form_element, _mergeProps({ errors: _ctx.errors, model: _ctx.model, loading: _ctx.loading }, { onSubmit: _ctx.onSubmit }), {
        buttons: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { name: 'forgot-password' },
            class: "login-form__forgot-password"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, _mergeProps({
            secondary: "",
            type: "submit"
          }, { loading: _ctx.loading }), {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 16)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_form_item, {
            label: "E-mail",
            name: 'email',
            rules: [_ctx.required, _ctx.email]
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
                class: "login-form__input",
                name: "email",
                type: "email",
                autocomplete: "login-email"
              }, null, 512), [
                [_vModelText, _ctx.model.email]
              ])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_form_item, {
            label: "Password",
            name: "password",
            rules: [_ctx.required]
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
                class: "login-form__input",
                name: "password",
                type: "password",
                autocomplete: "current-password"
              }, null, 512), [
                [_vModelText, _ctx.model.password]
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 16, ["onSubmit"]),
      _hoisted_5
    ]),
    _: 1
  }))
}